export default "__VITE_ASSET__BnlbB5nu__"